const EMAIL_LOG_EVENTS = {
  CONVERGED_EMAIL_PAGEVIEW: 'Converged Email Pageview'
}

export default EMAIL_LOG_EVENTS
